<div>
    <form class="form-container" name="exportWebKessForm" [formGroup]="exportWebKessForm" #ngForm="ngForm">
        <div class="my-4">
            <div class="row">
                <div class="col-xs-12 d-flex radio-grp flex-direction-column">
                    <div *ngIf="webKessEnabledDetails?.activateConsumption">
                        <div class="form-group form-group">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="customCheck10" name="exp"
                                    (change)="ConsumptionChange($event)" [checked]="uploadConsumption">
                                <label class="form-check-label"
                                    for="customCheck10">{{'WEBKESS_INTEGRATION.UPLOAD_CONSUMPTION' | translate}}</label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="webKessEnabledDetails?.activateObservation">
                        <div class="form-group">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="customCheckExpObs11" name="exp"
                                    (change)="ObservationChange($event)" [checked]="uploadObservation">
                                <label class="form-check-label"
                                    for="customCheckExpObs11">{{'WEBKESS_INTEGRATION.UPLOAD_OBSERVATIONS' |
                                    translate}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="notWebKessStationExists">
                    <p>{{ 'WEBKESS_INTEGRATION.EXPORT.STATION_WARNING' | translate }}</p>
                </div>
                <div class="col-sm-12">
                    <div class="form-floating form-group">
                      <div class="dropdown dropdown-bhp w-340px" >
                          <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                              <input type="text" formControlName="wardID" hidden />
                              <input class="dropdown-toggle" type="text" formControlName="wardName" readonly
                              [ngClass]="{ 'is-invalid':exportWebKessForm.get('wardName').errors &&
                              (exportWebKessForm.get('wardName').touched || exportWebKessForm.get('wardName').dirty || ngForm.submitted)}" />
                              <span class="label-dropdown">{{ 'WEBKESS_INTEGRATION.EXPORT.WARD' | translate }}*</span>
                              <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                          </div>
                          <ul class="dropdown-menu">
                              <li class="dropdown-item" [ngValue]="ward" class="dropdown-item"
                                  *ngFor="let ward of wardList" (click)="getDepartment(ward)"
                                  [ngClass]="{ 'not-webkess-station': !ward.iswebKessStation }">
                                  {{ ward.wardName | translate | labelSanitizer }}
                              </li>
                          </ul>
                      </div>
                  </div>
                </div>

                <div class="col-sm-12">
                    <div class="form-group">
                        <label>{{ translationKeys.Configure.Department | translate }}</label>
                        <p>{{choosenDepartmentName | labelSanitizer}}</p>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="form-floating form-group" *ngIf="uploadObservation">
                        <div class="dropdown dropdown-bhp w-340px">
                          <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                              <input class="dropdown-toggle" type="text" [value]="choosenPeriodName" readonly
                              [ngClass]="{ 'is-invalid':exportWebKessForm.get('period').errors &&
                              (exportWebKessForm.get('period').touched || exportWebKessForm.get('period').dirty || ngForm.submitted)}" />
                              <span class="label-dropdown">{{ translationKeys.Configure.Period | translate }}*</span>
                              <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                          </div>
                          <ul class="dropdown-menu">
                              <li class="dropdown-item" [ngValue]="period" class="dropdown-item"
                                  *ngFor="let period of availablePeriods" (click)="changePeriod(period)">
                                  {{period.startDate | date:dateFormat[langChoosen]}} - {{period.endDate |
                                  date:dateFormat[langChoosen]}} {{period.status == 'IMPORT_RUNNING' ? (isPeriodDeletion ?
                                  'Deletion in Progress' : (translationKeys.Webkess.ImportRunning | translate) ) : ''}}
                              </li>
                              <li class="dropdown-item" [value]="{name:'newperiod'}" (click)="changePeriod({name:'newperiod'})">{{ translationKeys.Configure.NewPeriod | translate }}
                              </li>
                          </ul>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="form-floating form-group" *ngIf="uploadConsumption">
                        <div class="dropdown dropdown-bhp w-340px" >
                          <div class="dropdown-container-input" data-toggle="dropdown" aria-expanded="false">
                              <input class="dropdown-toggle" type="text" formControlName="year" readonly
                              [ngClass]="{ 'is-invalid':exportWebKessForm.get('year').errors &&
                              (exportWebKessForm.get('year').touched || exportWebKessForm.get('year').dirty || ngForm.submitted)}" />
                              <span class="label-dropdown">{{ 'CONFIGURE.YEAR' | translate }}*</span>
                              <img class="dropdown-arrow" src="assets/icons/arrowDropdownOutlined.svg"  />
                          </div>
                          <ul class="dropdown-menu" >
                              <li class="dropdown-item" *ngFor="let year of allYears" [Value]="year" (click)="onYearChange(year)" >{{year}}</li>
                          </ul>
                        </div>
                    </div>
                </div>

                <div class="col-sm-12">
                    <div class="form-control form-control-width"
                        *ngIf="uploadObservation && choosenPeriod.name == 'newperiod'">
                        <div class="row mr-0 IEContain">
                            <div class="col-md-6 col-sm-12 pr-0">
                                <div class="form-group">
                                    <label for="startDate">{{ 'CONFIGURE.START_DATE' | translate }}</label>
                                    <mat-form-field appearance="fill"  class="date-form-field"
                                    [ngClass]="{'is-invalid':exportWebKessForm.get('startDate').errors && (exportWebKessForm.get('startDate').touched || exportWebKessForm.get('startDate').dirty || ngForm.submitted)}">
                                        <input (click)="startDatepicker.open()" placeholder="DD.MM.YYYY" matInput [matDatepicker]="startDatepicker" formControlName="startDate"
                                        [max]="endDate" readonly name="startDate">
                                        <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #startDatepicker></mat-datepicker>
                                    </mat-form-field>

                                    <div class="invalid-feedback"
                                        *ngIf="exportWebKessForm.get('startDate').errors && (exportWebKessForm.get('startDate').touched ||exportWebKessForm.get('startDate').dirty  || ngForm.submitted)">
                                        <span *ngIf="exportWebKessForm.get('startDate').errors.required">
                                            {{'ERROR_MESSAGES.REQUIRED.START_DATE' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6 col-sm-12 pr-0">
                                <div class="form-group">
                                    <label for="endDate">{{ 'CONFIGURE.END_DATE' | translate }}</label>
                                    <mat-form-field appearance="fill"  class="date-form-field"
                                        [ngClass]="{'is-invalid':exportWebKessForm.get('endDate').errors && (exportWebKessForm.get('endDate').touched || exportWebKessForm.get('endDate').dirty || ngForm.submitted)}">
                                        <input (click)="endDatepicker.open()" placeholder="DD.MM.YYYY" matInput [matDatepicker]="endDatepicker" formControlName="endDate"
                                        readonly name="endDate">
                                        <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
                                        <mat-datepicker #endDatepicker></mat-datepicker>
                                    </mat-form-field>

                                    <div class="invalid-feedback"
                                        *ngIf="exportWebKessForm.get('endDate').errors && (exportWebKessForm.get('endDate').touched ||exportWebKessForm.get('endDate').dirty  || ngForm.submitted)">
                                        <span *ngIf="exportWebKessForm.get('endDate').errors.required">
                                            {{'ERROR_MESSAGES.REQUIRED.END_DATE' | translate }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col my-4 d-flex" style="margin: 0 auto;">
                    <button class="btn-continue-bordered-bd mr-4 align-button separate-button"
                        *ngIf="!disableExport && !isImportRunning" (click)="exportSubmit();">{{
                        'WEBKESS_INTEGRATION.UPLOAD' | translate }}</button>
                    <button class="btn-continue-bordered-bd mr-4 align-button" *ngIf="!disableExport && deleteButtonVisible && !isImportRunning"
                        (click)="openCancelModal(cancelmodal,deletePeriodConfirmationModal);">{{
                        translationKeys.Webkess.DeletePeriod | translate }}</button>
                </div>
            </div>
            <div class="row alert" *ngIf="consumptionSended">
                <div class="alert alert-warning" role="alert" *ngIf="!isPeriodDeletion">
                    {{ translationKeys.Webkess.ImportRunning | translate }}
                </div>
                <div class="alert alert-warning" role="alert" *ngIf="isPeriodDeletion">
                    {{ translationKeys.Webkess.DeletionInProgress | translate }}
                </div>
            </div>
            <div class="row alert" *ngIf="!consumptionSended && isImportRunning">
                <div class="alert alert-warning" role="alert">
                    {{ 'WEBKESS_INTEGRATION.WEBKESS.RUNNING_IMPORT' | translate }}
                </div>
            </div>
        </div>
    </form>
</div>

<ng-template #cancelmodal>
    <div class="modal-header justify-content-between mb-4">
        <h5 class="modal-title">{{ translationKeys.InstitutionManagement.Confirmation | translate }}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef1.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p style="margin-left: auto; margin-right: auto; width: 60%;">
            {{ translationKeys.Observation.CloseUnsavedForm | translate}}
        </p>
        <p class="mt-2">
            {{ translationKeys.Observation.ConfirmClose | translate }}
        </p>
    </div>
    <div class="modal-footer">
        <button (click)="modalRef1.hide();" class="btn-cancel-bd separate-button">{{
            'LAYOUT_MODULE.STAY' | translate }}</button>
        <button (click)="openconfirmationModal()" class="btn-continue-bordered-bd">{{
            'LAYOUT_MODULE.LEAVE' | translate }}</button>
    </div>
</ng-template>

<ng-template #deletePeriodConfirmationModal>
    <div class="modal-header justify-content-between mb-4">
        <h5 class="modal-title">{{ translationKeys.Webkess.DeletionConfirmationHeader | translate}}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef4.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p>{{ translationKeys.Webkess.DeletionConformation | translate }}</p>
    </div>
    <div class="modal-footer">
        <button (click)="modalRef4.hide();" class="btn-cancel-bd separate-button">{{
            'BUTTON.CANCEL' | translate}}</button>
        <button (click)="deletionClick();" class="btn-continue-bordered-bd">{{
            'USER_MANAGEMENT.DELETE' | translate}}</button>
    </div>
</ng-template>
